import get from 'lodash/get'

export const getAvailableSections = (state) => get(state, 'seat.availableSections', [])
export const getAvailableRows = (state) => get(state, 'seat.availableRows', [])
export const getAvailableSeats = (state) => get(state, 'seat.availableSeats', [])
export const getAvailableSectionsLoading = (state) => get(state, 'seat.availableSectionsLoading', false)
export const getAvailableRowsLoading = (state) => get(state, 'seat.availableRowsLoading', false)
export const getAvailableSeatsLoading = (state) => get(state, 'seat.availableSeatsLoading', false)
